import { render, staticRenderFns } from "./AvailableHotels.vue?vue&type=template&id=78ce356b&"
import script from "./AvailableHotels.vue?vue&type=script&lang=js&"
export * from "./AvailableHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports